module.exports = __webpack_public_path__ + "static/media/ThaiRun_2021.12a42fab.png";